module.exports = __webpack_public_path__ + "static/img/404.83cd760.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cdpBase/images/404.jpg
// module id = MpNf
// module chunks = 19